export enum LoginType {
  INTERNO = 'interno',
  CONCESSIONARIA = 'concessionaria',
}
